// modules
import axios from "axios";

// constants
import { UNAUTHORISED, USER_INFO_COOKIE } from "constants/global";

// utils
import { getAccessToken, setCookie } from "utils/token";
import { refreshUserSession } from "utils/TokenUtils/refreshUserSession";

const apiKey = process.env.REACT_APP_API_KEY || "";

// Default headers
export const defaultHeaders = {
	// @Info: Not required. Commenting for future reference
	// "Cache-Control": "no-cache, no-store, max-age=0",
	"Content-Type": "application/json;charset=utf-8",
	"x-api-key": apiKey
}; //

export async function api() {
	let token = getAccessToken();
	if (!token) {
		let newSession;
		try {
			newSession = await refreshUserSession();
			const cookie_ttl = parseInt(newSession?.idToken.exp) - parseInt(newSession?.idToken.iat);
			setCookie(USER_INFO_COOKIE, JSON.stringify(newSession?.idToken), cookie_ttl);

			token = getAccessToken();
		} catch (error) {
			throw { return_description: UNAUTHORISED };
		}
	}

	return axios.create({
		baseURL: process.env.REACT_APP_API_HOST,
		headers: { ...defaultHeaders, Authorization: token }
	});
}

export async function customApi() {
	let token = getAccessToken();
	if (!token) {
		let newSession;
		try {
			newSession = await refreshUserSession();
			const cookie_ttl = parseInt(newSession?.idToken.exp) - parseInt(newSession?.idToken.iat);
			setCookie(USER_INFO_COOKIE, JSON.stringify(newSession?.idToken), cookie_ttl);

			token = getAccessToken();
		} catch (error) {
			throw { return_description: UNAUTHORISED };
		}
	}

	return axios.create({
		baseURL: "https://hftozuk7lr6v7segwzgjdcs5xi0uftxe.lambda-url.ap-southeast-1.on.aws",
		headers: { ...defaultHeaders, Authorization: token }
	});
}
